module.exports = __webpack_public_path__ + "static/media/uppvarmning.5fb55622.jpg";